import React, { useState } from 'react';

const Newsletter: React.FC = () => {
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const handleButtonMouseEnter = () => {
    setIsButtonHovered(true);
  };

  const handleButtonMouseLeave = () => {
    setIsButtonHovered(false);
  };

  return (
    <section className="relative h-[400px] md:h-[500px] flex items-center">
      {/* Background Image */}
      <img 
        src="/images/Newsletter.webp" 
        alt="Man looking at device" 
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Content Overlay */}
      <div className="relative z-20 mx-auto px-4 md:px-10 lg:px-32 w-full pt-20 pb-20">
        <div className="w-full lg:w-[45%]">
          {/* Heading */}
          <h2 className="text-[25px] md:text-[40px] lg:text-[40px] font-[700] leading-[40px] text-[#fff] mb-7 lg:text-left">
            Newsletter
          </h2>
          
          {/* Body Text */}
          <div className="text-[16px] md:text-[20px] lg:text-[20px] text-[#fff] leading-[29px] font-[400] mb-4 last:mb-0">
            <p>Ready to elevate your mining speculation game?</p>
            <p>Subscribe to our newsletter to receive expert insights from Rob</p>
          </div>
          
          {/* Call-to-Action Button */}
          <a 
            href="https://the-wealthy-miner.mn.co/"
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-block w-full md:w-auto bg-transparent border-2 border-[#FFF] px-8 md:px-16 lg:px-20 py-3 md:py-4 rounded-[10px] text-[14px] md:text-[16px] lg:text-[18px] font-[700] leading-[20px] md:leading-[24px] lg:leading-[32px] transition-all duration-300 transform text-center ${
              isButtonHovered ? 'bg-white text-[#1A2A44] scale-105' : 'text-[#FFFFFF] hover:bg-white hover:text-[#1A2A44] hover:scale-105'
            }`}
            onMouseEnter={handleButtonMouseEnter}
            onMouseLeave={handleButtonMouseLeave}
            aria-label="Join our newsletter"
          >
            JOIN OUR NEWSLETTER
          </a>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
